import { sbFromEnv } from "../lib/supabase";
import type { Database } from "../types/database";

const url = import.meta.env.VITE_SUPABASE_URL!;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY!;

const authOptions = {
  // Use the implicit flow so Supabase sets sessions immediately after
  // password or magic-link exchanges. The PKCE flow requires an extra
  // manual exchange step that our login flows do not implement, which
  // left the session empty even after successful authentication.
  detectSessionInUrl: true,
  persistSession: true,
};

export const supabase = sbFromEnv<Database>({
  url,
  key,
  options: {
    auth: { ...authOptions },
  },
});

// supabasePublic uses the same default "public" schema
export const supabasePublic = sbFromEnv<Database>({
  url,
  key,
  options: {
    auth: { ...authOptions },
  },
});
